import React, { useEffect, useState } from "react";
import "./Accordion.scss";
import plus from "../../assets/plus.svg"
import minus from "../../assets/minus.svg"

import eye from "../../assets/eye.svg"
import DoubleRangeSlider from "../DoubleRangeSlider/DoubleRangeSlider";



const Accordion = ({ items, icon, isOpen, isSmall, layout }) => {
    const [activeIndex, setActiveIndex] = useState(isOpen ? 0 : null);
    const [range, setRange] = useState({ min: 200, max: 500 });
    useEffect(() => {
        const filter = JSON.parse(localStorage.getItem("ECOM_CAT_PROD"))?.ProductFilter;
        const rangeVal = filter?.PriceRanges
        const min = rangeVal.find(item => item.Key === "MinPrice")?.Value
        const max = rangeVal.find(item => item.Key === "MaxPrice")?.Value
        setRange({ min: min, max: max })
    }, [items])
    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };
    const getPriceContent = (controlName) => {
        const filter = JSON.parse(localStorage.getItem("ECOM_CAT_PROD"))?.ProductFilter;
        const rangeVal = filter?.PriceRanges
        const min = rangeVal.find(item => item.Key === "MinPrice")?.Value
        const max = rangeVal.find(item => item.Key === "MaxPrice")?.Value
        if (controlName === "Price")
            return (
                <DoubleRangeSlider
                    min={min}
                    max={max}
                    minValue={range.min}
                    maxValue={range.max}
                    onChange={(newRange) => {
                        setRange(newRange)
                    }}
                />
            )
    }
    const layout1 = () => {
        const filter = JSON.parse(localStorage.getItem("ECOM_CAT_PROD"))?.ProductFilter;

        return Object.keys(items).map((item, index) => {
            const controlName = items[item]?.ControlName;

            const isExcluded = controlName === "ProductCategory" || controlName === "ProductSubCategory";

            const isVisible =
                (controlName === "Price" && filter?.PriceRanges?.length > 0) ||
                (controlName === "Weight" && filter?.Weight) ||
                (controlName === "Brand" && filter?.BrandIDs?.length > 0);

            const show = !isExcluded && isVisible;

            return (
                controlName && show && (
                    <div className="accordion-item" key={index}>
                        <div
                            className={`accordion-header ${activeIndex === index ? "active" : ""}`}
                            onClick={() => toggleAccordion(index)}
                        >
                            <div className={isSmall ? "header-content-small" : "header-content"}>
                                {icon && <img alt="" src={eye} />}
                                {items[item]?.ControlLabel}
                            </div>
                            <div className="accordion-icon">
                                <img alt="" src={activeIndex === index ? minus : plus} />
                            </div>
                        </div>
                        <div className={`accordion-content ${activeIndex === index ? "open" : ""}`}>
                            {getPriceContent(controlName)}
                        </div>
                    </div>
                )
            );
        });
    };

    const layout2 = () => {
        return (
            items.map((item, index) => (
                <div className="accordion-item" key={index}>
                    <div
                        className={`accordion-header ${activeIndex === index ? "active" : ""
                            }`}
                        onClick={() => toggleAccordion(index)}
                    >
                        <div className={isSmall ? "header-content-small" : "header-content"}>
                            {icon && <img alt="" src={eye} />}
                            {item?.title}
                        </div>
                        <div className="accordion-icon">
                            <img alt="" src={activeIndex === index ? minus : plus} />
                        </div>
                    </div>
                    <div
                        className={`accordion-content ${activeIndex === index ? "open" : ""
                            }`}
                    >
                        {item?.content}
                    </div>
                </div>
            ))
        )
    }
    const getLayouts = () => {
        switch (layout) {
            case "layout1":
                return layout1()

            case "layout2":

                return layout2()

            default:
                return layout2()
        }

    }
    return (
        <div className="accordion">
            {getLayouts()}
        </div>
    );
};

export default Accordion;
